import React, { Dispatch, SetStateAction } from "react";
import { Label } from "@twilio-paste/label";
import { TextArea } from "@twilio-paste/core/textarea";
import { HelpText } from "@twilio-paste/help-text";
import styles from "../../styles";

interface ModalTAProps {
  label: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  placeholder?: string;
  readonly?: boolean;
  maxLength?: number;
  help_text?: string;
  //inputType?: InputType;
  isFocused?: boolean;
  id?: string;
  disabled?: boolean;
}

const ModalTAField: React.FC<ModalTAProps> = (props: ModalTAProps) => {
  return (
    <>
      <Label htmlFor="mtextarea">
        <div>{props.label}</div>
      </Label>
      <TextArea
        id="mtextarea"
        autoFocus={props.isFocused ?? false}
        placeholder={props.placeholder}
        onChange={(e) => props.onChange(e.currentTarget.value)}
        readOnly={props.readonly ?? false}
        hasError={!!props.error}
        onBlur={props.onBlur}
        disabled={props.disabled}
      />
      {props.error && (
        <HelpText id="error_help_text" variant="error">
          {props.error}
        </HelpText>
      )}
      {!props.error && props.help_text && (
        <HelpText id="error_help_text">{props.help_text}</HelpText>
      )}
    </>
  );
};

export default ModalTAField;
